"use strict";
import Log from "@cbook/shared/utils/Log";
export default Log;
